import base from '../dr-base'
import drSignType from './dr-sign-type.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-sign-type',
  name: 'SignType',
  group: 'EDS widgets',
  icon: 'outdent',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.disabled',
      type: 'string',
      default: ''
    },
    Required: {
      name: 'vuetifyWidgets.general.required',
      type: 'boolean'
    },
    Value: {
      name: 'vuetifyWidgets.dr-sign-type.signTypeField',
      type: 'string'
    },
    Style: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    FieldType: {
      name: 'vuetifyWidgets.dr-sign-type.fieldType',
      type: 'string',
      enum: [{
        value: 'signType',
        text: 'vuetifyWidgets.dr-sign-type.signType'
      } ,{
        value: 'signSubtype',
        text: 'vuetifyWidgets.dr-sign-type.signSubtype'
      } ,{
        value: 'asicType',
        text: 'vuetifyWidgets.dr-sign-type.asicType'
      }]
    },
    Readonly: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.readonly',
      type: 'string'
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-autocomplete-elem.generationOnChange'
    }
  }
}


export default {
  schema,
  component: drSignType,
  propEditors: [
    {
      name: 'dr-autocomplete-data-source-editor'
    },
    {
      name: 'dr-prop-action'
    }
  ]
}